require("core-js/modules/esnext.global-this.js");

!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], r) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).ChevronRight = e.ChevronRight || {}, e.ChevronRight.js = r(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, r, t) {
  "use strict";

  function l(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  function n(e) {
    if (e && e.__esModule) return e;
    var r = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var l = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(r, t, l.get ? l : {
          enumerable: !0,
          get: function get() {
            return e[t];
          }
        });
      }
    }), r.default = e, Object.freeze(r);
  }

  var a = n(e),
      i = l(r);

  function o(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }

  function u() {
    return u = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var l in t) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }

      return e;
    }, u.apply(this, arguments);
  }

  function f(e, r) {
    if (null == e) return {};

    var t,
        l,
        n = function (e, r) {
      if (null == e) return {};
      var t,
          l,
          n = {},
          a = Object.keys(e);

      for (l = 0; l < a.length; l++) {
        t = a[l], r.indexOf(t) >= 0 || (n[t] = e[t]);
      }

      return n;
    }(e, r);

    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);

      for (l = 0; l < a.length; l++) {
        t = a[l], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
      }
    }

    return n;
  }

  function c(e, r) {
    return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(r)
      }
    }));
  }

  var s,
      b,
      p = {
    small: 14,
    default: 16,
    large: 20,
    xlarge: 24
  };

  var d = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
      y = function y(e) {
    var r,
        l = e.className,
        n = e.size,
        i = void 0 === n ? 16 : n,
        y = e.title,
        g = e["aria-label"],
        h = e["aria-labelledby"],
        v = e.fill,
        m = e.role,
        O = void 0 === m ? "img" : m,
        j = f(e, d),
        C = t.css(s || (s = c(["\n    color: ", ";\n  "])), v),
        w = t.css(b || (b = c(["\n    flex-shrink: 0;\n  "]))),
        x = function (e, r, t) {
      var l,
          n,
          a = t["aria-label"],
          i = t["aria-labelledby"],
          u = t.title;

      switch (e) {
        case "img":
          return a || i || u ? (o(l = {}, "aria-labelledby", i), o(l, "aria-label", a), o(l, "title", u), l) : {
            "aria-label": (n = r, "".concat(n.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
          };

        case "presentation":
          return {
            "aria-hidden": !0,
            alt: ""
          };
      }
    }(O, "ChevronRight", (o(r = {
      title: y
    }, "aria-label", g), o(r, "aria-labelledby", h), r));

    return a.createElement("svg", u({
      className: t.cx(o({}, C, null != v), w, l),
      height: "number" == typeof i ? i : p[i],
      width: "number" == typeof i ? i : p[i],
      role: O
    }, x, j, {
      viewBox: "0 0 16 16"
    }), a.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.36396 14.364C5.75449 14.7545 6.38765 14.7545 6.77818 14.364L11.7279 9.41421L12.435 8.70711C12.8256 8.31658 12.8256 7.68342 12.435 7.29289L11.7279 6.58579L6.77817 1.63604C6.38765 1.24552 5.75449 1.24551 5.36396 1.63604L4.65685 2.34315C4.26633 2.73367 4.26633 3.36684 4.65685 3.75736L8.89949 8L4.65685 12.2426C4.26633 12.6332 4.26633 13.2663 4.65686 13.6569L5.36396 14.364Z",
      fill: "currentColor"
    }));
  };

  return y.displayName = "ChevronRight", y.isGlyph = !0, y.propTypes = {
    fill: i.default.string,
    size: i.default.oneOfType([i.default.number, i.default.string]),
    className: i.default.string
  }, y;
});